import React from 'react';

function Contacts() {
    return (
        <div className='title'>
            <h1>Nous contacter</h1>
        </div>
    );
}

export default Contacts;